(function () {
  Flint.file('mframework/views/textBox.js', function (require) {
    'use strict';

    Flint.staticStyles('TextBox', {
      '$': '#_flintapp .ViewTextBox'
    }, {
      '$': {}
    });
    Flint.view('TextBox', function (view, on, $) {
      var pro = initPro(view, {
        autoFocus: M.defaultAtom(false),
        autoSelect: M.defaultAtom(false),
        enabled: M.defaultAtom(true),
        multiline: M.defaultAtom(false),
        initialValue: M.defaultAtom(''),
        value: atom(),
        inpStyle: M.mapAtom({}),
        placeholder: atom(),
        tabIndex: atom(),
        type: M.defaultAtom('text'),
        pattern: atom()
      });

      if (view.props.onInit) {
        view.props.onInit(view);
      }

      var inp = atom();
      var hovering = atom(false);

      view.focus = function () {
        inp.get() && inp.get().focus();
      };

      view.blur = function () {
        inp.get() && inp.get().blur();
      };

      var value = atom(pro.initialValue.get());
      pro.value.react(function (propValue) {
        if (propValue != null) {
          value.set(propValue);
        }
      });

      value.react(function (value) {
        if (inp.get() && inp.get().value != value) {
          inp.get().value = value;
        }
      });

      var onChange = function onChange(newValueFromUser) {
        if (pro.value.get() == null) {
          value.set(newValueFromUser);
        }

        view.props.onChange && view.props.onChange({ value: newValueFromUser });
      };

      var onKeyDown = function onKeyDown(e) {
        if (e.key == 'Enter' && view.props.onEnter) {
          view.props.onEnter({ value: value.get() });
        } else if (e.key == 'Escape' && view.props.onEscape) {
          view.props.onEscape({ value: value.get() });
        }

        if (view.props.onKeyDown) view.props.onKeyDown({ event: e });
      };

      var onFocus = function onFocus(e) {
        if (pro.autoSelect.get()) {
          on.delay(1, function () {
            if (inp.get()) {
              inp.get().select();
            }
          });
        }
        if (view.props.onFocus) view.props.onFocus(e);
      };
      var onBlur = function onBlur(e) {
        if (view.props.onBlur) view.props.onBlur(e);
      };

      var onMouseEnter = function onMouseEnter(e) {
        hovering.set(true);
        if (view.props.onMouseEnter) view.props.onMouseEnter(e);
      };
      var onMouseLeave = function onMouseLeave(e) {
        hovering.set(false);
        if (view.props.onMouseLeave) view.props.onMouseLeave(e);
      };
      hovering.react(function (hovering) {
        if (view.props.onHover) view.props.onHover({ hovering: hovering });
      });view.render(function () {
        return Flint.iff(!pro.multiline.get()) && view.el(['input', 1], { className: 'inp', if: !pro.multiline.get(),
          ref: function (elem) {
            if (elem) inp.set(elem);
          },
          type: pro.type.get() || 'text',
          pattern: pro.pattern.get(),
          autoFocus: pro.autoFocus.get(),
          defaultValue: value.get(),
          disabled: !pro.enabled.get(),
          onChange: function (e) {
            return onChange(e.target.value);
          },
          onKeyDown: onKeyDown,
          onFocus: onFocus,
          onBlur: onBlur,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave,
          style: pro.inpStyle.get().toJS(),
          placeholder: pro.placeholder.get(),
          tabIndex: pro.tabIndex.get(),
          onClick: view.props.onClick
        });
      });view.render(function () {
        return Flint.iff(pro.multiline.get()) && view.el(['textarea', 1], { className: 'inp', if: pro.multiline.get(),
          ref: function (elem) {
            if (elem) inp.set(elem);
          },
          autoFocus: pro.autoFocus.get(),
          defaultValue: value.get(),
          disabled: !pro.enabled.get(),
          onChange: function (e) {
            return onChange(e.target.value);
          },
          onKeyDown: onKeyDown,
          onFocus: onFocus,
          onBlur: onBlur,
          onMouseEnter: onMouseEnter,
          onMouseLeave: onMouseLeave,
          placeholder: pro.placeholder.get(),
          style: pro.inpStyle.get().toJS(),
          tabIndex: pro.tabIndex.get(),
          onClick: view.props.onClick
        });
      });
    });
  })
})();
//# sourceMappingURL=textBox.js.map
